import { GridCustomFilterCellProps } from '@progress/kendo-react-grid';
import {
  getPrevMaintenanceStatusOptions,
  prevMaintenanceStatusToTypeMap,
} from '../../../utils/textMappings';
import { PrevMaintenanceStatusDropDownFilterCell } from './PrevMaintenanceStatusDropDownFilterCell';
import { GetString } from '../../StringResourceManager';

export const PreventiveMaintenanceStatusFilterCell: any = (
  props: GridCustomFilterCellProps
) => (
  <PrevMaintenanceStatusDropDownFilterCell
    {...props}
    data={getPrevMaintenanceStatusOptions()}
    defaultItem={GetString('SELECT_STATUS')}
    onChangeValueCheckFunc={prevMaintenanceStatusToTypeMap}
  />
);
